export default __webpack_public_path__ + "static/media/keyicon.6d1076ad.png";